// Redux
import { combineReducers } from 'redux'

// Redux Persistent
import { persistReducer } from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'

// Reducers
import cartReducer from './reducer/cartReducer'
import clientReducer from './reducer/clientReducer'
import menuReducer from './reducer/menuReducer'
import storeReducer from './reducer/storeReducer'

const persistConfig = {
    storage: storageSession,
    key: 'root',
    storageSession,
    whitelist: ['cartData', 'clientData', 'menuData', 'storeData']
}

const rootReducer = combineReducers({
    cartData: cartReducer,
    clientData: clientReducer,
    menuData: menuReducer,
    storeData: storeReducer,
})

export default persistReducer(persistConfig, rootReducer)